<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import { authHeader } from "../../../helpers/auth-header";

import ConfirmationModal from "@/components/modals/confirmation-modal";
import MessageModal from "@/components/modals/message-modal";

import InputGroup from "@/components/forms/input-group";
import SelectGroup from "@/components/forms/select-group";
import SaveButton from "@/components/buttons/save-button";

/**
 * Orders Component
 */
export default {
    components: {
        Layout,
        PageHeader,
        ConfirmationModal,
        MessageModal,
        InputGroup,
        SelectGroup,
        SaveButton,
    },
    data() {
        const id = this.$route.params.id;
        const modeName = id === 'add' ? 'Add' : 'Edit';

        return {
            id: id,
            title: `Staff ${modeName}`,
            modeName,
            items: [
                {
                    text: "Staff"
                },
                {
                    text: modeName,
                    active: true,
                },
            ],
            data: {
                name: '',
                phone: '',
                email: '',
                password: '',
                password_confirmation: '',
                branch: '',
                status: 1,
                products: [],
                calendar_color_code: '',
            },

            statusOptions: [
                { name: 'Active', value: 1 },
                { name: 'Inactive', value: 0 },
            ],
            branchOptions: [],
            categoryOptions: [],
            colorOptions: [
                { name: 'Yellow', value: '-139' },
                { name: 'Grey', value: '-16181' },
                { name: 'Purple', value: '-16776961' },
                { name: 'Orange', value: '-8388608' },
                { name: 'Pink', value: '-39772' },
                { name: 'Green', value: '-16744448' },
                { name: 'Light Blue', value: '-16711681' },
            ],
            commissionOptions: [
                { name: 'Fixed Amount', value: 'fixed_amount' },
                { name: 'Percentage', value: 'percentage' },
            ],
            errors: {},
            allProducts: [],
            selectedProducts: [],
            selectAll: false,
        };
    },
    // async created() {
    //     if (this.modeName === 'Edit') {
    //         try {
    //             const result = await axios.get(`${process.env.VUE_APP_APIURL}/staff/${this.id}`, {
    //                 headers: authHeader(),
    //             });
    //             if (result && result.data['code'] === 'success') {
    //                 const data = result.data['data']['staff'];
    //                 for (const [key, item] of Object.entries(data)) {
    //                     if (key in this.data) {
    //                         this.data[key] = item;
    //                     }
    //                 }

    //                 const branch_id = result.data['data']['staffBranch'][0].id;
    //                 this.data['branch'] = branch_id;

    //                 const staffProducts = result.data?.data?.staff?.products || [];

    //                 this.data.products = staffProducts;
    //                 this.selectedProducts = staffProducts.map(p => p.product_id);
    //             }
    //         } catch (e) {
    //             console.error(e);
    //         }
    //     }

    //     if (this.data.products && this.data.products.length > 0) {
    //         if (this.modeName === 'Add') {
    //             // For Add mode, select all by default
    //             this.selectedProducts = this.data.products.map(product => product.id);
    //         } else {
    //             // For Edit mode, initialize with existing products
    //             this.selectedProducts = this.data.products.map(product => product.product_id);
    //         }
    //     }
    // },
    computed: {

    },
    watch: {
        //
    },
    async mounted() {
        this.retrieveBranches().then((branches) => {
            this.branchOptions = branches.map((branch) => ({
                name: branch.name,
                value: branch.id,
            }));
        });

        if (this.modeName === 'Edit') {
            await this.loadStaff();   // ✅ WAIT for staff data first
        }

        await this.loadAllProducts(); // ✅ THEN load products

        if (this.modeName === 'Edit') {
            this.mergeStaffProductsWithAllProducts(); // ✅ THEN merge
        }

        if (this.modeName === 'Add') {
            this.selectedProducts = this.allProducts.map(product => product.id);
            this.allProducts = this.allProducts.map(product => ({
                ...product,
                selected: true
            }));
            this.updateSelectAllState();
        }
    },
    methods: {
        async retrieveBranches() {
            this.loading = true;
            let branches = [];

            try {
                const item = await axios.get(`${process.env.VUE_APP_APIURL}/branch`, {
                    headers: authHeader(),
                });

                const result = await item.data;
                if (result['code'] === 'success') {
                    branches = result['data'].branches;
                    branches = branches.filter(branch => branch.status === 1);
                }
            } catch (e) {
                console.error(e);
            }

            this.loading = false;
            return branches;
        },

        async loadAllProducts() {
            try {
                const item = await axios.get(`${process.env.VUE_APP_APIURL}/product/simple`, {
                    headers: authHeader(),
                });

                const result = await item.data;
                if (result['code'] === 'success') {
                    this.allProducts = result['data'].products.map(product => ({
                        ...product,
                        default_commission_type: product.commission_type || '',
                        default_commission: product.commission || '',
                        commission_type: product.commission_type || '',
                        commission: product.commission || '',
                        selected: false
                    }));
                }
            } catch (e) {
                console.error(e);
            }
        },

        mergeStaffProductsWithAllProducts() {
            this.allProducts = this.allProducts.map(product => {
                const staffProduct = this.data.products?.find(
                    p => Number(p.product_id) === Number(product.id)
                );

                console.log('MATCH:', staffProduct);

                if (staffProduct) {
                    return {
                        ...product,
                        commission_type: staffProduct.commission_type ?? product.default_commission_type,
                        commission: staffProduct.commission_value ?? product.default_commission,
                        selected: true
                    };
                }

                return {
                    ...product,
                    commission_type: product.default_commission_type,
                    commission: product.default_commission,
                    selected: false
                };
            });
        },

        async loadStaff() {
            try {
                const result = await axios.get(
                    `${process.env.VUE_APP_APIURL}/staff/${this.id}`,
                    { headers: authHeader() }
                );

                if (result && result.data['code'] === 'success') {
                    const data = result.data['data']['staff'];

                    for (const [key, item] of Object.entries(data)) {
                        if (key in this.data) {
                            this.data[key] = item;
                        }
                    }

                    const branch_id = result.data['data']['staffBranch'][0].id;
                    this.data['branch'] = branch_id;

                    const staffProducts = result.data?.data?.staff?.products || [];

                    this.data.products = staffProducts;
                    this.selectedProducts = staffProducts.map(p => p.product_id);
                }
            } catch (e) {
                console.error(e);
            }
        },

        toggleProduct(productId) {
            const index = this.selectedProducts.indexOf(productId);
            if (index === -1) {
                // Add to selected
                this.selectedProducts.push(productId);
            } else {
                // Remove from selected
                this.selectedProducts.splice(index, 1);
            }

            // Update product's selected state in allProducts
            const productIndex = this.allProducts.findIndex(p => p.id === productId);
            if (productIndex !== -1) {
                this.allProducts[productIndex].selected = !this.allProducts[productIndex].selected;
            }
            
            // Update selectAll state
            this.updateSelectAllState();
        },

        // Toggle select all checkboxes
        toggleSelectAll() {
            if (this.selectAll) {
                // Unselect all
                this.selectedProducts = [];
                this.allProducts = this.allProducts.map(product => ({
                    ...product,
                    selected: false
                }));
            } else {
                // Select all
                this.selectedProducts = this.allProducts.map(product => product.id);
                this.allProducts = this.allProducts.map(product => ({
                    ...product,
                    selected: true
                }));
            }
            this.selectAll = !this.selectAll;
        },

        updateSelectAllState() {
            if (this.allProducts && this.allProducts.length > 0) {
                this.selectAll = this.selectedProducts.length === this.allProducts.length;
            } else {
                this.selectAll = false;
            }
        },

        isProductSelected(productId) {
            return this.selectedProducts.includes(productId);
        },

        async save() {
            this.errors = {};

            let requestData = JSON.parse(JSON.stringify(this.data));

            requestData.products = this.allProducts
                .filter(product => this.selectedProducts.includes(product.id))
                .map(product => ({
                    product_id: product.id,
                    commission_type: product.commission_type,
                    commission: product.commission
                }));

            let result;
            if (this.modeName === 'Add') {
                result = await axios.post(`${process.env.VUE_APP_APIURL}/staff`, requestData, {
                    headers: authHeader(),
                });
            } else {
                result = await axios.put(`${process.env.VUE_APP_APIURL}/staff/${this.id}`, requestData, {
                    headers: authHeader(),
                });
            }

            if (result) {
                if (result.data['code'] === 'success') {
                    if (this.modeName === 'Add') {
                        this.$router.back();
                    } else {
                        this.$refs.messageModal.showModal('Your record has been updated successfully');
                    }
                } else if (result.data['code'] === 'invalid_field') {
                    this.errors = result.data['errors'];
                }                
            }
        },
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ConfirmationModal ref="confirmationModal" />
        <MessageModal ref="messageModal" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body p-3">
                        <b-tabs content-class="mt-3">
                            <b-tab title="Info" active>
                                <div class="row">
                                    <div class="col-12 col-md-8 col-lg-12">
                                        <div class="row">
                                            <div class="col-12 col-md-4 mb-2">
                                                <InputGroup type="email" id="email" displayName="Email*" v-model="data.email" :error="errors.email" />
                                            </div>
                                            <div class="col-12 col-md-4 mb-2">
                                                <InputGroup type="text" id="name" displayName="Name*" v-model="data.name" :error="errors.name" />
                                            </div>
                                            <div class="col-12 col-md-4 mb-2">
                                                <InputGroup type="text" id="phone" displayName="Phone*" v-model="data.phone" :error="errors.phone" />
                                            </div>                                            
                                            <div class="col-12 col-md-4 mb-2" v-if="modeName === 'Add'">
                                                <InputGroup type="password" id="password" displayName="Password*" v-model="data.password" :error="errors.password" />
                                            </div>
                                            <div class="col-12 col-md-4 mb-2" v-if="modeName === 'Add'">
                                                <InputGroup type="password" id="password_confirmation" displayName="Password Confirmation*" v-model="data.password_confirmation" :error="errors.password" />
                                            </div>
                                            <div class="col-12 col-md-4 mb-2">
                                                <SelectGroup id="branch" displayName="Branch*" v-model="data.branch" :error="errors.branch" :options="branchOptions" />
                                            </div>
                                            <div class="col-12 col-md-4 mb-2">
                                                <SelectGroup id="color" displayName="Calendar Color" v-model="data.calendar_color_code" :error="errors.calendar_color_code" :options="colorOptions" />
                                            </div>
                                            <div class="col-12 col-md-4 mb-2">
                                                <SelectGroup id="status" displayName="Status*" v-model="data.status" :error="errors.status" :options="statusOptions" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title="Treatment">
                                <div class="table-container" style="max-height: 80vh; overflow-y: auto;">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <input 
                                                        type="checkbox" 
                                                        :checked="selectAll"
                                                        @change="toggleSelectAll"
                                                        :disabled="!allProducts || allProducts.length === 0"
                                                    />
                                                </th>
                                                <th>Treatment ID</th>
                                                <th>Name</th>
                                                <th>SKU</th>
                                                <th>Commission</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="allProducts && allProducts.length > 0">
                                            <tr v-for="product in allProducts" :key="product.id">
                                                <td>
                                                    <input 
                                                        type="checkbox" 
                                                        :checked="isProductSelected(product.id)"
                                                        @change="toggleProduct(product.id)"
                                                    />
                                                </td>
                                                <td>
                                                    {{ product.id }}
                                                </td>
                                                <td>
                                                    {{ product.name ?? '-' }}
                                                </td>
                                                <td>
                                                    {{ product.sku }}
                                                </td>
                                                <td>
                                                    <SelectGroup :id="'commission_type_' + product.id" displayName="Commission Type" v-model="product.commission_type" :options="commissionOptions" />
                                                    <InputGroup type="text" :id="'commission_' + product.id" displayName="Commission" :hideLabel="false" v-model="product.commission" :error="errors[`products.${product.id}.commission`]" />
                                                </td>
                                            </tr>                                        
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <td colspan="5" class="text-center py-3">
                                                    No products available
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </b-tab>
                        </b-tabs>
                        <SaveButton @click="save" class="mt-5" />
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
.table th:first-child {
    text-align: center;
    vertical-align: middle;    
}

.table td:first-child {
    text-align: center;
}

.form-check-input {
    margin: 0;
    cursor: pointer;
}

.table-container {
    /* overflow-x: auto; */
}
</style>